import type {
  AccessPolicyDocument,
  AppConfigPublishResult,
  LLMConfigDocumentView,
  LLMConfigPublishRequest,
  LLMConfigRollbackRequest,
  LLMConfigValidation,
} from '@/types';
import api from './api';

export type RawLLMDocument = Record<string, unknown>;

const paths = {
  gateway: '/api/v1/app-config/gateway-catalog',
  access: '/api/v1/app-config/llm-access-policy',
} as const;

export const llmConfigApi = {
  getGatewayCatalog: async (): Promise<LLMConfigDocumentView<RawLLMDocument>> =>
    api.get(paths.gateway),

  validateGatewayCatalog: async (
    document: RawLLMDocument,
  ): Promise<LLMConfigValidation> =>
    api.post(`${paths.gateway}/validate`, { document }),

  publishGatewayCatalog: async (
    payload: LLMConfigPublishRequest<RawLLMDocument>,
  ): Promise<AppConfigPublishResult> => api.post(paths.gateway, payload),

  rollbackGatewayCatalog: async (
    payload: LLMConfigRollbackRequest,
  ): Promise<AppConfigPublishResult> =>
    api.post(`${paths.gateway}/rollback`, payload),

  getAccessPolicy: async (): Promise<
    LLMConfigDocumentView<AccessPolicyDocument>
  > => api.get(paths.access),

  validateAccessPolicy: async (
    document: AccessPolicyDocument,
  ): Promise<LLMConfigValidation> =>
    api.post(`${paths.access}/validate`, { document }),

  publishAccessPolicy: async (
    payload: LLMConfigPublishRequest<AccessPolicyDocument>,
  ): Promise<AppConfigPublishResult> => api.post(paths.access, payload),

  rollbackAccessPolicy: async (
    payload: LLMConfigRollbackRequest,
  ): Promise<AppConfigPublishResult> =>
    api.post(`${paths.access}/rollback`, payload),
};
